import { teamMemberService } from "../../../../../Api/Services/TeamMembers";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import { IBaseResponse } from "../../../../../Types/UserProfileDetails";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";
import { IBulkAttendanceParams } from "../../types";

export const bulkApprovedAttendance = createServiceAsyncThunk<
  IBaseResponse,
  IBulkAttendanceParams
>(
  ACTION_NAMES.UPDATE_BULK_ATTENDANCE_APPROVED,
  ({ action, attendance_request_ids }) =>
    teamMemberService.bulkApprovedAttendanceRequest({
      attendance_request_ids,
      action,
    }),
  ERROR_MESSAGES.UPDATE_BULK_ATTENDANCE_APPROVED_FAILURE
);

export const bulkApprovedAttendanceSlice = createGenericSlice<
  IBaseResponse,
  IBulkAttendanceParams
>(SLICE_NAMES.BULK_ATTENDANCE_APPROVED_SLICE, bulkApprovedAttendance);

export const {
  clearError: clearBulkApprovedAttendanceError,
  clearSuccessMessage: clearBulkApprovedAttendanceSuccess,
} = bulkApprovedAttendanceSlice.actions;

export default bulkApprovedAttendanceSlice.reducer;
